import { render, staticRenderFns } from "./PromotionStat.vue?vue&type=template&id=f00e2238&scoped=true"
import script from "./PromotionStat.vue?vue&type=script&lang=js"
export * from "./PromotionStat.vue?vue&type=script&lang=js"
import style0 from "./PromotionStat.vue?vue&type=style&index=0&id=f00e2238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00e2238",
  null
  
)

export default component.exports